// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import WidgetHostConfigResourceViewModel from '../../../../viewModel/resource/WidgetHostConfigResourceViewModel';
import WidgetHostConfigResourceDTO from '../../dto/resource/WidgetHostConfigResourceDTO';

export default abstract class WidgetHostConfigResourceModel extends BaseModel<WidgetHostConfigResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  * @type {int64}
  */
  get creatorId() { return this.dto.creatorId; }
  set creatorId(value) { this.dto.creatorId = value; }
  /**
  */
  get creatorName() { return this.dto.creatorName; }
  set creatorName(value) { this.dto.creatorName = value; }
  /**
  * @type {date-time}
  */
  get created() { return this.dto.created; }
  set created(value) { this.dto.created = value; }
  /**
  * @type {int64}
  */
  get modifierId() { return this.dto.modifierId; }
  set modifierId(value) { this.dto.modifierId = value; }
  /**
  */
  get modifierName() { return this.dto.modifierName; }
  set modifierName(value) { this.dto.modifierName = value; }
  /**
  * @type {date-time}
  */
  get modified() { return this.dto.modified; }
  set modified(value) { this.dto.modified = value; }
  /**
  */
  get name() { return this.dto.name; }
  set name(value) { this.dto.name = value; }
  /**
  */
  get hostKey() { return this.dto.hostKey; }
  set hostKey(value) { this.dto.hostKey = value; }
  /**
  */
  get loaderUrl() { return this.dto.loaderUrl; }
  set loaderUrl(value) { this.dto.loaderUrl = value; }
  /**
  */
  get allowedReferers() { return this.dto.allowedReferers; }
  set allowedReferers(value) { this.dto.allowedReferers = value; }
  /**
  */
  get languageIso2() { return this.dto.languageIso2; }
  set languageIso2(value) { this.dto.languageIso2 = value; }
  /**
  */
  get locale() { return this.dto.locale; }
  set locale(value) { this.dto.locale = value; }
  /**
  */
  get entryPoint() { return this.dto.entryPoint; }
  set entryPoint(value) { this.dto.entryPoint = value; }
  /**
  */
  get navigation() { return this.dto.navigation; }
  set navigation(value) { this.dto.navigation = value; }
  /**
  */
  get startParameters() { return this.dto.startParameters; }
  set startParameters(value) { this.dto.startParameters = value; }
  /**
  */
  get apiKey() { return this.dto.apiKey; }
  set apiKey(value) { this.dto.apiKey = value; }
  /**
  */
  get isDebug() { return this.dto.isDebug; }
  set isDebug(value) { this.dto.isDebug = value; }
  /**
  */
  get isActive() { return this.dto.isActive; }
  set isActive(value) { this.dto.isActive = value; }
  /**
  */
  get textContentScope() { return this.dto.textContentScope; }
  set textContentScope(value) { this.dto.textContentScope = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    value = Number.parseFloat(qs.creatorid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.creatorId = value;
    this.dto.creatorName = qs.creatorname;
    this.dto.created = qs.created;
    value = Number.parseFloat(qs.modifierid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.modifierId = value;
    this.dto.modifierName = qs.modifiername;
    this.dto.modified = qs.modified;
    this.dto.name = qs.name;
    this.dto.hostKey = qs.hostkey;
    this.dto.loaderUrl = qs.loaderurl;
    this.dto.allowedReferers = qs.allowedreferers;
    this.dto.languageIso2 = qs.languageiso2;
    this.dto.locale = qs.locale;
    this.dto.entryPoint = qs.entrypoint;
    this.dto.navigation = qs.navigation;
    this.dto.startParameters = qs.startparameters;
    this.dto.apiKey = qs.apikey;
    value = qs.isDebug === 'true' ? true : qs.isdebug;
    value = qs.isDebug === 'false' ? false : undefined;
    this.dto.isDebug = value;
    value = qs.isActive === 'true' ? true : qs.isactive;
    value = qs.isActive === 'false' ? false : undefined;
    this.dto.isActive = value;
    this.dto.textContentScope = qs.textcontentscope;
  }
}
